const accessPayments = {

    PAYMENT_LIST: { name: 'Payments', path: '/payments/payment' },
    CHARGES_LIST: { name: 'Charges', path: '/payments/charges' },

}

export default accessPayments;
